export const PageData = {
    introduction: [
    {
        heading: "Introduction",
        id: 1,
        text: [
            {
                id: 1,
                subtitle: "Opening: ",
                body: "Dreaming of living and working in the United States? The Diversity Visa (DV) Lottery, also known as the Green Card Lottery, might be your ticket! Each year, 55,000 lucky winners from around the world are randomly selected to receive a U.S. Green Card, giving them the opportunity to become permanent residents.",
            },
            {
                id: 2,
                subtitle: "Goal: ",
                body: "In this blog, we’ll explain what the DV Lottery is, who is eligible, and how GIT Global can help you apply for your chance to win a Green Card!",
            },
        ]
    },
    {
        heading: "What is the DV Lottery?",
        id: 2,
        text: [
            {
                id: 1,
                body: "The DV Lottery, or Diversity Visa Lottery, was created by the U.S. government to promote diversity in the immigrant population. It’s a completely free lottery that gives people from countries with low immigration rates to the U.S. a chance to win permanent residency (a Green Card).",
            },
        ]
    },
    ],
    bridge: [
        {
            heading: "Eligibility for the DV Lottery",
            subheading: "To participate in the DV Lottery, you must meet two main eligibility requirements:",
            id: 1,
            text: [
                {
                    id: 1,
                    subtitle: "Country of Birth:",
                    body: "You must be a native of a country that is eligible for the program. The list of eligible countries changes each year, based on the number of immigrants from those countries in the past five years. If your country isn’t eligible, you may still apply if your spouse or parents were born in an eligible country.",
                },
                {
                    id: 2,
                    subtitle: "Education or Work Experience:",
                    body: "You need to have at least a high school education or its equivalent, OR two years of work experience in the last five years in a job that requires at least two years of training or experience.",
                },
            ]
        },
    ],
    howToApply: [
        {
            heading: "How to Apply for the DV Lottery",
            subheading: "The DV Lottery application process is simple, but it’s important to do it correctly to avoid disqualification. Here’s a step-by-step guide:",
            id: 1,
            procedures: [
                {
                    title: "Submit Your Application Online:",
                    id: 1,
                    steps: [
                        {
                            id: 1,
                            text: "Applications are submitted online via the official U.S. Department of State website during the designated application period (usually between October and November each year).",
                        },
                        {
                            id: 2,
                            text: "The application is free—beware of any websites asking for payment!",
                        }
                    ]
                },
                {
                    title: "Fill Out the Form:",
                    id: 2,
                    steps: [
                        {
                            id: 1,
                            text: "You’ll need to provide basic information such as your name, date of birth, country of birth, education or work experience, and passport details.",
                        },
                        {
                            id: 2,
                            text: "A passport-style photo that meets U.S. requirements must also be submitted with your application.",
                        },
                    ]
                },
                {
                    title: "Submit Your Application:",
                    id: 3,
                    steps: [
                        {
                            id: 1,
                            text: "Only one application per person is allowed. Submitting multiple entries will disqualify you.",
                        },
                    ]
                },
                {
                    title: "Keep Your Confirmation Number:",
                    id: 4,
                    steps: [
                        {
                            id: 1,
                            text: "After submitting your application, you’ll receive a confirmation number. Be sure to save this number, as it’s the only way to check whether you’ve been selected in the lottery",
                        },
                    ]
                },
            ]
        },
    ],
    afterApplication: [
        {
            heading: "What Happens After You Apply?",
            subheading: "The U.S. Department of State conducts a random drawing from all eligible entries. If you’re selected, you’ll be notified and given instructions on how to apply for your Green Card.",
            id: 1,
            procedures: [

            ]
        },
        {
            heading: "What to Do If You’re Selected",
            subheading: "Being selected for the DV Lottery doesn’t automatically grant you a Green Card—it gives you the opportunity to apply for one. Here’s what you’ll need to do:",
            id: 2,
            procedures: [
                {
                    title: "Submit Additional Forms:",
                    id: 1,
                    steps: [
                        {
                            id: 1,
                            text: "If selected, you’ll need to submit more detailed forms, such as the DS-260, which is used for immigrant visa applicants.",
                        },
                    ]
                },
                {
                    title: "Attend a Visa Interview:",
                    id: 2,
                    steps: [
                        {
                            id: 1,
                            text: "You’ll attend an interview at a U.S. embassy or consulate where you’ll be asked about your background, reasons for immigration, and your qualifications.",
                        },
                    ]
                },
                {
                    title: "Complete Medical Exams and Provide Supporting Documents:",
                    id: 3,
                    steps: [
                        {
                            id: 1,
                            text: "Medical exams and other supporting documents (such as birth certificates, police clearance certificates, etc.) will also be required.",
                        },
                    ]
                },
                {
                    title: "Receive Your Green Card:",
                    id: 4,
                    steps: [
                        {
                            id: 1,
                            text: "If everything is approved, you’ll receive an immigrant visa, allowing you to travel to the U.S. Once you arrive, you’ll receive your Green Card by mail, officially making you a permanent resident of the United States!",
                        },
                    ]
                },
            ]
        },
    ],
    howGitHelps: [
        {
            heading: "How GIT Global Can Help You",
            id: 1,
            text: [
                {
                    id: 1,
                    subtitle: "Application Assistance: ",
                    body: "GIT Global can help guide you through the DV Lottery application process, ensuring you avoid any mistakes that could disqualify you.",
                },
                {
                    id: 2,
                    subtitle: "Post-Selection Support: ",
                    body: "If you’re selected in the lottery, GIT Global offers assistance with the next steps, including filling out the additional forms, preparing for the visa interview, and gathering all the necessary documents.",
                },
                {
                    id: 3,
                    subtitle: "Expediting the Process: ",
                    body: "We’ll help you ensure that everything is completed correctly and on time so you can focus on starting your new life in the U.S.!",
                },
            ]
        },
    ],

    conclusion: [
        {
            heading: "Conclusion",
            id: 1,
            text: [
                {
                    id: 1,
                    subtitle: "",
                    body: "The DV Lottery offers a once-in-a-lifetime opportunity to win a U.S. Green Card. With the right guidance, your dream of living and working in the United States could become a reality. At GIT Global, we’re here to help you every step of the way.",
                },
            ]
        },
    ],
    
}
